import Vue from "vue";
import VueRouter from "vue-router";
import loginPage from "../pages/LoginPage";
import homePage from "../pages/HomePage";
import forgotPassword from "../pages/ForgotPassword";
import resetEmail from "../pages/ResetEmail";
import resetPassword from "../pages/ResetPassword";
import studentList from "../pages/StudentList";
import student from "../pages/Student/Student";
import parentList from "../pages/ParentList";
import parent from "../pages/Parent";
import manageRelationship from "../pages/ManageRelationship";
import staffNewsfeed from "../pages/StaffPost";
import pendingPost from "../pages/PendingPost";
import parentRegister from "../pages/ParentRegister";
import attendanceList from "../pages/AttendanceList";
import backdateAttendance from "../pages/BackdateAttendance";
import attendanceAuditTrail from "../pages/AttendanceAuditTrail";
import gallery from "../pages/Gallery";
import promotion from "../pages/Promotion";
import report from "../pages/Report";
import notFound from "../pages/notFound/NotFound";
import dailyRoutine from "../pages/DailyRoutine";
import dailyRoutine2 from "../pages/DailyRoutine2";
import pendingApprover from "../pages/PendingApprover";
import postapprove from "../pages/PostApprove";
import myAccount from "../pages/MyAccount";
import myChild from "../pages/MyChild";
import approvermaster from "../pages/ApproverMaster";
import AttendanceICAReport from "../pages/AttendanceICAReport";
import transferIn from "../pages/TransferIn";
import studentgraduation from "../pages/StudentGraduation";
import classManagement from "../pages/ClassManagement";
import studentPaymentPlan from "../pages/StudentPaymentPlan";
import event from "../pages/Event";
import eventEmail from "../pages/EventBlastEmail";
import busMaster from "../pages/BusMaster";
import dailyRoutineMassUpdate from "../pages/DailyRoutineMassUpdate";
import busAttendance from "../pages/BusAttendance";
import ecaMaster from "../pages/EcaMaster";
import ecaAttendance from "../pages/EcaAttendance";
import attendanceReport from "../pages/AttendanceReport";
import studentReceiptDetail from "../pages/StudentReceiptDetail";
import studentListPayment from "../pages/StudentListPayment";
import studentCourseList from "../pages/StudentCourseList";
import batchPaymentList from "../pages/BatchPaymentList";
import cancelSchedule from "../pages/CancelSchedule";
import classAttendanceReport from "../pages/ClassAttendanceReport";
import invoiceList from "../pages/InvoiceList";
import AgentTracker from "../pages/AgentTracker";
import AgencyListSummary from "../pages/AgencyListSummary";
import AgencyStudentList from "../pages/AgencyStudentList";
import attendanceMaster from "../pages/AttendanceMaster";
import classOverview from "../pages/ClassOverview";
import portfolioMedia from "../pages/PortfolioMedia";
import plannerMaster from "../pages/PlannerMaster";
import plannerAssignSchool from "../pages/PlannerAssignSchool";
import plannerAssignStudent from "../pages/PlannerAssignStudent";
import plannerAssignLevel from "../pages/PlannerAssignLevel";
import secretAdminConfigPage from "../pages/SecretAdminConfigPage";
import plannerStudentProgress from "../pages/PlannerStudentProgress";
import transactionListing from "../pages/TransactionListing";
import studentListReport from "../pages/StudentListReport";
import salesLedgerReport from "../pages/SalesLedgerReport";
import publicPage from "../pages/Public/PublicPage";
import newFeed from "../pages/NewFeed";
import newMedia from "../pages/NewMedia";
import newBroadcast from "../pages/NewBroadcast";
import newEvent from "../pages/NewEvent";
import batchItemList from "../pages/BatchItemList";
import newStudentInfo from "../pages/NewStudentInfo";
import password from "../pages/Protected";
import payment from "../pages/payment/Payment";
import eventPublic from "../pages/Public/PublicEvent";
import loginPageParent from "../pages/LoginPageParent";
import parentRegisterByLink from "../pages/ParentRegisterByLink";
import navigationMaster from "../pages/NavigationMaster";
import pickupAcknowledgement from "../pages/PickupAcknowledgement";
import portfolioDetails from "../pages/PortfolioDetails";
import withdrawForm from "../pages/WithdrawForm";
import plannerapprove from "../pages/PlannerApprove";
import studentSiblingReport from "../pages/StudentSiblingReport";
import fpsReport from "../pages/FPSReport";
import fpsReport2 from "../pages/FPSReport2";
import studentMovementReport from "../pages/StudentMovementReport";
import thankYouPage from "../pages/ThankYouPage";
import travelDeclarationPublic from "../pages/Public/PublicTravelDeclaration";
import travelDeclarationReport from "../pages/TravelDeclarationReport";
import postPortfolio from "../pages/PostPortfolio";
import eventPostBack from "../pages/EventPostBack";
import rebateList from "../pages/RebateList";
import staffMainPage from "../pages/StaffMainPage";
import termlyReport from "../pages/termlyReport/TermlyReport";
import newMyAccount from "../pages/NewMyAccount";
import addApplicationQuestion from "../pages/AddApplicationQuestion";
import applicationManagement from "../pages/ApplicationManagement";
import applicationList from "../pages/ApplicationList";
import incidentForm from "../pages/IncidentForm";
import incidentList from "../pages/IncidentList";
import agingReport from "../pages/AgingReport";
import staffScanTemperature from "../pages/StaffScanTemperature";
import thankyouPayment from "../pages/ThankyouPayment";
import EhStudentApplicationForm from "../pages/application/EhStudentApplicationForm";
import MisStudentApplicationForm from "../pages/application/MisStudentApplicationForm";
import dailyRoutineParent from "../pages/DailyRoutineParent";
import staffScanTemperatureWithStud from "../pages/StaffScanTemperatureWithStud";
import userManagementForAdmin from "../pages/UserManagementForAdmin";
import parentregisterstatusreport from "../pages/ParentRegisterStatusReport";
import c19declarationreport from "../pages/C19DeclarationReport";
import attendancelistview from "../pages/AttendanceListView";
import staffScanTemperatureWithBarCode from "../pages/StaffScanTemperatureWithBarCode";
import emailCampaign from "../pages/email/emailCampaign";
import activityPage from "../pages/activity/activityPage";
import newActivityPage from "../pages/activity/newActivityPage";
import activityJapanPage from "../pages/activityJapan/activityPage";
import newActivityJapanPage from "../pages/activityJapan/newActivityPage";
import feeCalculator from "../pages/FeeCalculator";
import dashboardPage from "../pages/dashboard/dashboardPage";
import dashboardStatePage from "../pages/dashboard/dashboardStatePage";
import PlannerAssignClass from "../pages/PlannerAssignClass";
import AlumniReport from "../pages/alumniReport/alumniReport";
import SchoolFeeReport from "../pages/SchoolFeeReport/SchoolFeeReport";
import GroupSchoolFeeReport from "../pages/GroupSchoolFeeReport/GroupSchoolFeeReport";

import PlannerCloneClass from "../pages/PlannerCloneClass";
import activityDownloadPage from "../pages/activity/activityDownloadPage";
import AttendanceSubject from "../pages/AttendanceSubject";
import StudentAttendanceReport from "../pages/AttendanceReports/StudentAttendanceReport";
import DailyAttendanceReport from "../pages/DailyAttendanceReport/DailyAttendanceReport";
import ApfRedirectFromKagami from "@/pages/application/ApfRedirectFromKagami";
import studentMealReport from "../pages/StudentMealReport";
import studentAdditionalLangReport from "../pages/StudentAdditionalLangReport";
import DownloadPreview from "../pages/download/downloadPreview";
import FinanceNotification from "../pages/FinanceNotifcation/FinanceNotification";
import schoolManagementForAdmin from "../pages/SchoolManagementForAdmin";
import schoolManagementForAdminEdit from "../pages/SchoolManagementForAdminEdit";
import WithdrawEnrolmentReport from "../pages/WithdrawEnrolmentReport/WithdrawEnrolmentReport";
import StaffEventCalendar from "../pages/StaffEventCalendar";
import Academica from "../pages/academica/Academica";
import attendanceMonitoring from "../pages/iframe/attendanceMonitoring";
import PlannerLevel from "../pages/planner/PlannerLevel";
import PlannerLevelAssign from "../pages/planner/PlannerLevelAssign";
import PlannerClass from "../pages/planner/PlannerClass";
import onlineWithdrawalForm from "../pages/withdrawal/onlineWithdrawalFormPage.vue";
import withdrawalStatusList from "../pages/withdrawal/withdrawalStatusListPage.vue";
import withdrawalManagement from "../pages/withdrawal/withdrawalManagementPage.vue";
import WdfRedirectFromKagami from "../pages/withdrawal/WdfRedirectFromKagamiPage.vue";
import NewAttendanceReportDaily from "@/pages/NewAttendanceReportDaily.vue";
import NewAttendanceReportMonthly from "@/pages/NewAttendanceReportMonthly.vue";
import RedirectToMobilePost from "@/pages/RedirectToMobilePost.vue";
import ParentNotFoundPage from "@/pages/notFound/parentNotFoundPage";
import { getStaffPortalStatus } from "@/helper/util_custom";
import PreStudentApplicationForm from "@/pages/application/PreStudentApplicationForm";
import { parentRoute, staffRoute } from "@/router/routerList";

Vue.use(VueRouter);
let isJapan = window.location.host.toUpperCase().includes(process.env.VUE_APP_ROOT_API7.toUpperCase());
console.log(isJapan, "isJapan");
let router = {};

if (getStaffPortalStatus()) {
   router = new VueRouter({
      mode: "history",
      routes: staffRoute
   });
} else if (window.location.host.toUpperCase().includes(process.env.VUE_APP_ROOT_API4.toUpperCase())) {
   router = new VueRouter({
      mode: "history",
      routes: parentRoute
   });
} else if (window.location.host.toUpperCase().includes(process.env.VUE_APP_ROOT_API6.toUpperCase())) {
   router = new VueRouter({
      mode: "history",
      routes: [
         {
            path: "/Public/StudentApplicationForm",
            name: "MisStudentApplicationForm",
            component: MisStudentApplicationForm,
            meta: { bodyClass: "application-form" }
         }
      ]
   });
}

function guardMyroute(to, from, next) {
   const isAuthenticated = localStorage.getItem("LoggedUser") === "true";
   const loggedInAt = localStorage.getItem("LoggedInAt");
   const authCheck = isAuthenticated && loggedInAt && Number(new Date) - new Date(loggedInAt) < 3600 * 1000;
   if (authCheck) {
      next();
   } else {
      next({
         path: "/Public/protected",
         query: {
            ID: to.query.ID
         }
      });
   }
}

export default router;
